// Diverging palette anchored pink (low) → grey (neutral) → blue (high). Each
// scale size gets its own ordered set so every bin renders a distinct color
// (sampling a 5-stop palette with round() collapsed neighbors on 6/7-bin scales).
const PALETTES: Record<number, string[]> = {
    1: ["bg-valence-grey-200"],
    2: ["bg-valence-pink-600", "bg-valence-blue-600"],
    3: ["bg-valence-pink-600", "bg-valence-grey-200", "bg-valence-blue-600"],
    4: ["bg-valence-pink-600", "bg-valence-pink-200", "bg-valence-blue-200", "bg-valence-blue-600"],
    5: ["bg-valence-pink-600", "bg-valence-pink-200", "bg-valence-grey-200", "bg-valence-blue-200", "bg-valence-blue-600"],
    6: ["bg-valence-pink-800", "bg-valence-pink-600", "bg-valence-pink-200", "bg-valence-blue-200", "bg-valence-blue-600", "bg-valence-blue-800"],
    7: ["bg-valence-pink-800", "bg-valence-pink-600", "bg-valence-pink-200", "bg-valence-grey-200", "bg-valence-blue-200", "bg-valence-blue-600", "bg-valence-blue-800"],
};

const FALLBACK = PALETTES[5];

export function paletteColor(index: number, total: number): string {
    const palette = PALETTES[total];
    if (palette) {
        return palette[index] ?? palette[palette.length - 1];
    }
    if (total <= 1) {
        return FALLBACK[2];
    }
    const t = index / (total - 1);
    const idx = Math.round(t * (FALLBACK.length - 1));
    return FALLBACK[idx];
}
